import { useMutation } from '@tanstack/react-query';
import saveAs from 'save-as';

import { useToast } from 'Store/toast';
import getExportOperatorViolations from 'Api/report-attendance-operator-detail/getExportOperatorViolations';
import { exportReportText } from 'Const/report-attendance/text';
import { useLoader } from 'Store/loader';

import getOperatorViolationsRequest from './model/request/getOperatorViolationsRequest';

const useGetExportOperatorViolations = () => {
  const { onShowLoader, onResetLoader } = useLoader();
  const { onOpenToast } = useToast();

  return useMutation({
    mutationFn: async (filter) => {
      onShowLoader({ variant: 'loader-primary' });
      const queries = getOperatorViolationsRequest(filter);

      const response = await getExportOperatorViolations(queries);

      return { response };
    },
    onSuccess: ({ response }) => {
      const filename = `Report Attendance Operator Violations.xlsx`;

      const blob = new Blob([response]);

      saveAs(blob, filename);

      onOpenToast({
        status: 'success',
        description: exportReportText.successExportText,
        duration: 3,
        alwaysShow: false,
      });
    },
    onError: (error) => {
      console.log(error);

      onOpenToast({
        status: 'error',
        description: exportReportText.failedExportText,
        duration: 5,
        alwaysShow: false,
      });
    },
    onSettled: () => {
      onResetLoader();
    },
  });
};

export default useGetExportOperatorViolations;
